import { conditionService, VariableConditionContext } from 'utils/adl-services';

export function getVariableCondition({ matcher, variableRefId, defaultValue }) {
  if (!matcher) {
    throw new Error('No default matcher provided for getVariableCondition');
  }
  return conditionService.createCondition(
    defaultValue,
    new VariableConditionContext(variableRefId),
    matcher,
  );
}

export function variableRefIdInLogic(
  { variablesWithQuestionnaireLogic, variablesWithDisqualificationLogic } = {},
  refId,
) {
  const hasVariableWithLogic =
    variablesWithQuestionnaireLogic.variables.includes(refId);
  const hasVariableWithDisqualificationLogic =
    variablesWithDisqualificationLogic.variables.includes(refId);
  return {
    hasVariable: hasVariableWithLogic || hasVariableWithDisqualificationLogic,
    hasVariableWithLogic,
    hasVariableWithDisqualificationLogic,
  };
}

export function variableValueRefIdInLogic(
  { variablesWithQuestionnaireLogic, variablesWithDisqualificationLogic } = {},
  refId,
) {
  const hasVariableValueWithLogic =
    variablesWithQuestionnaireLogic.variableValues.includes(refId);
  const hasVariableValueWithDisqualificationLogic =
    variablesWithDisqualificationLogic.variableValues.includes(refId);
  return {
    hasVariableValue:
      hasVariableValueWithLogic || hasVariableValueWithDisqualificationLogic,
    hasVariableValueWithLogic,
    hasVariableValueWithDisqualificationLogic,
  };
}
